module.exports = __webpack_public_path__ + "img/icon_checked.d49a712d.png";